module.exports = "\n<span>\n    <img :style=\"style\" :class=\"class\" :src=\"'data:image/svg+xml;base64,' + this.svg\" />\n</span>\n";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/javascript/components/ui/Avatar.vue
// module id = ./node_modules/vue-html-loader/index.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/javascript/components/ui/Avatar.vue
// module chunks = 54